import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { Input } from '@skbkontur/react-ui';
import { ValidationWrapper } from '@skbkontur/react-ui-validations';
import { maskFormatChars } from '../../constants/constants';
import { normalizeStr } from '../../helpers/formatters';
export const TrimmedInput = ({ removeAllSpace, onValueChange, onBlur, validationInfo, renderMessage, debounce, mask, onFocus, ...props }) => {
    const timerRef = useRef(null);
    const inputRef = useRef(null);
    const [maskState, setMaskState] = useState(null);
    const handleValueChange = (input) => {
        if (!onValueChange) {
            return;
        }
        if (!debounce) {
            onValueChange(input);
        }
        if (timerRef.current) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
        }
        timerRef.current = window.setTimeout(() => {
            onValueChange(input);
        }, debounce);
    };
    const handleBlur = (e) => {
        if (onValueChange) {
            const value = e.target.value;
            const normalized = removeAllSpace ? value.replace(/\s+/g, '') : normalizeStr(value);
            value !== normalized && onValueChange(normalized);
        }
        onBlur && onBlur(e);
    };
    const handleFocus = (e) => {
        if (onValueChange && props.value && props.value !== e.target.value) {
            onValueChange(e.target.value);
        }
        setMaskState(mask);
        onFocus && onFocus(e);
    };
    useEffect(() => {
        if (!maskState) {
            return;
        }
        inputRef.current?.focus();
    }, [maskState]);
    const element = (_jsx(Input, { ref: inputRef, onBlur: handleBlur, onValueChange: handleValueChange, formatChars: maskFormatChars, mask: maskState, onFocus: handleFocus, ...props }));
    if (validationInfo === undefined) {
        return element;
    }
    return (_jsx(ValidationWrapper, { validationInfo: validationInfo, renderMessage: renderMessage, children: element }));
};
